import React from "react";
import { Tag } from "antd";

const REVIEW_STATUS_COLOR_MAP = {
  Pending: "orange",
  Approved: "green",
  "Approved as Noted": "green",
  Rejected: "red",
  "Revise and Resubmit": "red",
  Void: "red",
  "For Record Only": "lime",
  Reviewed: "lime",
  Submitted: "default",
};

/**
 * Same pill styling as the Review Status column on the Submittals table.
 */
export default function ReviewStatusTag({ status, emptyLabel = "-" }) {
  if (!status) {
    return <span>{emptyLabel}</span>;
  }
  const color = REVIEW_STATUS_COLOR_MAP[status] || "default";
  return (
    <Tag color={color} style={{ fontWeight: "bold" }}>
      {status}
    </Tag>
  );
}
